<script>
  import Icon from "../../icon/Icon.svelte";
  /**
   * @typedef {Object} Props
   * @property {boolean} [rotate]
   */

  /** @type {Props} */
  let { rotate = false } = $props();
</script>

<style>
  .icon {
    transition: transform 500ms ease-in-out;
    display: inline;
  }
  .rotate {
    transform: rotate(180deg);
  }
  @media (min-width: 768px) {
    .icon {
      display: none;
    }
  }
</style>

<span class="icon" class:rotate>
  <Icon
    role="presentation"
    id="#arrow"
    width="8.27"
    height="12"
    fill="#8c8c8c" />
</span>
